// extracted by mini-css-extract-plugin
export default {"root":"PlasmicAdTemplate_root__zhhPa","button":"PlasmicAdTemplate_button__jpm0D","buttonselected":"PlasmicAdTemplate_buttonselected__Y4ZVB"};